




































import AccountList from "@/views/h5-page/account/AccountList.vue";
import GroupList from "@/views/h5-page/account/GroupList.vue";
import AddAccount from "@/views/h5-page/account/Component/AddAccount.vue";
import { Tab, Tabs, Button } from "vant";
import Vue from "vue";
export const EventBus = new Vue();

export default {
  components: {
    AddAccount,
    AccountList,
    GroupList,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Button.name]: Button
  },

  data() {
    return {
      active: 0,
      list: [],
      loading: false,
      finished: true,
      showAdd: false,
      isAdd: false,
      activeIndex: 0,
      refresh: false,
      planFlag: false
    };
  },
  watch: {
    activeIndex(newIndex) {
      (this as any).activeIndex = newIndex;
    }
  },
  mounted(){
    (this as any).queryExchangeInfo();
    // (this as any).getTradeSettings();
    (this as any).updateActiveIndex((this as any).$route.query);
  },
  methods: {
    updateActiveIndex(query) {
      // 参数校验：确保query存在且query.activeIndex是数字
      if (query && typeof query.activeIndex === 'string' && !isNaN(query.activeIndex)) {
        const activeIndex = parseInt(query.activeIndex, 10);
        // 判断activeIndex是否在预期范围内
        if ([0, 1].includes(activeIndex)) {
          (this as any).activeIndex = activeIndex;
          (this as any).planFlag = true;
        } else {
          
        }
      }
    },
    // 获取用户的交易设置
    getTradeSettings() {
      (this as any).$apis
        .getTransactionSettingList({})
        .then(res => {
          let obj = JSON.stringify(res);
          // create_order 下单确认设置 0 未开启 1开启
          // cancel_order 撤单确认设置 0 未开启 1开启
          // update_order 改单确认设置 0 未开启 1开启
          localStorage.setItem('transactionSet',obj);
        })
        .catch(e => {
          
        });
    },
    //获取交易所信息
    queryExchangeInfo(){
      (this as any).$apis
      .queryExchangeInfo()
      .then(async(res) => {
        let obj = JSON.stringify(res.data.exchange_info);
        localStorage.setItem('exchangeList',obj);
      })
      .catch(e => {
          
      });
    },
    onload() {},
    success() {
      
      if ((this as any).refresh) {
        (this as any).refresh = false;
      } else {
        (this as any).refresh = true;
      }
    },
    addClose() {
      (this as any).isAdd = false;
      (this as any).showAdd = false;
    },
    outputRedirect() {
      const that = (this as any);
      // 通过计划页过来的
      if (that.planFlag) {
        clearTimeout(that.timer);
        that.timer = setTimeout(() => {
          that.$router.back();
          that.planFlag = false;
        }, 100);
      }
    }
  }
};
